import { useSupabaseAuthContext } from '../components/SupabaseAuthProvider.jsx'

export function useSupabaseAuth() {
  return useSupabaseAuthContext()
}

